export enum PrivateRoutesEnum {
  LK = '/lk',
  MY_MODEL = '/myModel',
  ALL_MODEL = '/allModel',
  ADMINISTRATION = '/administration',
  JOURNAL = '/journal',
}

export const enum ErrorUrlEnum {
  ERROR = '/error',
  ERROR_403 = '/403',
  ERROR_404 = '/404',
  ERROR_503 = '/503',
  ERROR_500 = '/500',
}
